import React from 'react';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { processLink } from '../../../shared/processLink';
import { ReachButton } from '../../ReachButton/ReachButton';
import './AwardLink.scss';

export interface AwardLinkProps {
    theme: `white` | `gray` | `dark`;
    awardContext: AwardContextProps[];
}

interface AwardContextProps {
    contentText: string;
    link?: AwardLinkUri;
    image?: {
        blueLine: IGatsbyImageData;
        whiteSticker: IGatsbyImageData;
        blueSticker: IGatsbyImageData;
    };
}

interface AwardLinkUri {
    title: string;
    uri: string;
}

export const AwardLink = (props: AwardLinkProps) => {
    if (!props) return;

    const { theme, awardContext } = props;

    enum ImageTheme {
        white = `whiteSticker`,
        dark = `blueSticker`,
        gray = `blueLine`,
    }

    return (
        <section className={`themed-container award ${theme ?? `light`}`}>
            <ul className="award-wrapper">
                {awardContext?.map((award, idx) => (
                    <li key={idx} className="award-link">
                        {award.image && (
                            <div className="img" data-testid={`${theme}-icon`}>
                                <GatsbyImage
                                    image={award.image[ImageTheme[theme]]}
                                    alt=""
                                />
                            </div>
                        )}
                        <p>
                            <span>{award.contentText}</span>
                            {award.link && (
                                <span className="buttons">
                                    <ReachButton
                                        href={processLink(award.link.uri)}
                                        buttonStyle="borderless"
                                        buttonIcon={{
                                            icon: `ki-arrow-right`,
                                            position: `right`,
                                            iconSize: `1rem`,
                                        }}
                                    >
                                        <span className="sr-only">
                                            {award.link.title}
                                        </span>
                                    </ReachButton>
                                </span>
                            )}
                        </p>
                    </li>
                ))}
            </ul>
        </section>
    );
};
